import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';
import { fetchDraftReviews } from '../services/reviewService';

export const useDraftReviews = (draftId) => {
  const { apiCall, isAuthenticated } = useAuth();

  return useInfiniteQuery({
    queryKey: ['draftReviews', draftId],
    queryFn: ({ pageParam = null }) => fetchDraftReviews(apiCall, draftId, pageParam),
    getNextPageParam: (lastPage) => lastPage.hasMore ? lastPage.nextCursor : undefined,
    initialPageParam: null,
    enabled: !!isAuthenticated && !!apiCall && !!draftId,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      if (error?.status === 404 || error?.status === 401 || error?.status === 403) {
        return false;
      }
      return failureCount < 2;
    },
  });
};